import { render, staticRenderFns } from "./roleClone.vue?vue&type=template&id=6ac20cec&scoped=true"
import script from "./roleClone.vue?vue&type=script&lang=js"
export * from "./roleClone.vue?vue&type=script&lang=js"
import style0 from "./roleClone.vue?vue&type=style&index=0&id=6ac20cec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac20cec",
  null
  
)

export default component.exports